import { ReductionObjectiveType } from 'src/app/shared/model/reduction-objective';

/**
 * The company objectives one trip can be measured against, in the order the
 * impact page lists them, with the label the objectives page gives each, the
 * sentence stating its target in the simulation panel, the unit suffix of its
 * figures, and the trip's figure — the formula the objectives page averages
 * over the company's trips, null when the trip lacks what it divides by.
 *
 * `EMISSION_REDUCTION_VS_YEAR` is a yearly trend, which no single trip has.
 * The two legacy types are no longer offered on the objectives page.
 */
export const TRIP_OBJECTIVES: ReadonlyArray<{
  type: ReductionObjectiveType;
  labelKey: string;
  targetLabelKey: string;
  unitKey: string;
  measure: (
    totalImpact: number,
    trip: { travellers: number; days: number; price: number | null },
  ) => number | null;
}> = [
  {
    type: 'AVG_EMISSION_PER_TRAVELLER',
    labelKey: 'objectives.avgEmissionPerTraveller',
    targetLabelKey: 'reductionTips.goals.objectiveOf.perTraveller',
    unitKey: 'reductionTips.goals.unit.perTraveller',
    measure: (totalImpact, { travellers }) => totalImpact / travellers,
  },
  {
    type: 'AVG_EMISSION_PER_TRAVELLER_PER_DAY',
    labelKey: 'objectives.avgEmissionPerTravellerPerDay',
    targetLabelKey: 'reductionTips.goals.objectiveOf.perTravellerPerDay',
    unitKey: 'reductionTips.goals.unit.perTravellerPerDay',
    measure: (totalImpact, { travellers, days }) =>
      totalImpact / travellers / days,
  },
  {
    type: 'EMISSION_PER_TRIP_REVENUE',
    labelKey: 'objectives.emissionPerTripRevenue',
    targetLabelKey: 'reductionTips.goals.objectiveOf.perKiloEuro',
    unitKey: 'reductionTips.goals.unit.perKiloEuro',
    measure: (totalImpact, { price }) =>
      price ? totalImpact / (price / 1000) : null,
  },
];

export type TripObjective = (typeof TRIP_OBJECTIVES)[number];
